import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTTAG,
  DELETE_PRODUCTTAG,
  UPDATE_PRODUCTTAG,
  ADD_NEW_PRODUCTTAG,
} from "./actionType";

import {
  getProductTagSuccess,
  getProductTagFail,
  deleteProductTagSuccess,
  deleteProductTagFail,
  updateProductTagSuccess,
  updateProductTagFail,
  addProductTagSuccess,
  addProductTagFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getProductTagApi,
  updateProductTagApi,
  deleteProductTagApi,
  addNewProductTagApi
} from "../../helpers/backend_helper";

function* getProductTag({ payload: productTag }) {
  try {
    const response = yield call(getProductTagApi, productTag);
    yield put(getProductTagSuccess(GET_PRODUCTTAG, response.data));
  } catch (error) {
    yield put(getProductTagFail(GET_PRODUCTTAG, error));
  }
}

function* onUpdateProductTag({ payload: productTag }) {
  try {
    const response = yield call(updateProductTagApi, productTag);
    yield put(updateProductTagSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateProductTagFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductTag({ payload: productTag }) {
  try {
    const response = yield call(deleteProductTagApi, productTag);
    yield put(deleteProductTagSuccess({ productTag, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductTagFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductTag({ payload: productTag }) {
  try {
    const response = yield call(addNewProductTagApi, productTag);
    yield put(addProductTagSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductTagFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductTag() {
  yield takeEvery(GET_PRODUCTTAG, getProductTag);
}

export function* watchUpdateProductTag() {
  yield takeEvery(UPDATE_PRODUCTTAG, onUpdateProductTag);
}

export function* watchDeleteProductTag() {
  yield takeEvery(DELETE_PRODUCTTAG, onDeleteProductTag);
}

export function* watchAddNewProductTag() {
  yield takeEvery(ADD_NEW_PRODUCTTAG, onAddNewProductTag);
}

function* productTagSaga() {
  yield all([
    fork(watchGetProductTag),
    fork(watchDeleteProductTag),
    fork(watchUpdateProductTag),
    fork(watchAddNewProductTag)
  ]);
}

export default productTagSaga;
